import { render, staticRenderFns } from "./exportDataPage.vue?vue&type=template&id=203176ce&scoped=true"
import script from "./exportDataPage.vue?vue&type=script&lang=js"
export * from "./exportDataPage.vue?vue&type=script&lang=js"
import style0 from "./exportDataPage.vue?vue&type=style&index=0&id=203176ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203176ce",
  null
  
)

export default component.exports